<template>
    <div class="container">
        <div class="col-12">
            <LogoLoading v-if="!services" />
            <div v-else>
                <div v-for="(service, index) in services" :key="index">
                    <h2 class="text-bold text-center text-secondary">{{ service.titles[currentLanguage] }}</h2>
                    <div class="row mt-5">
                        <div class="col-12 col-md-4 d-flex gap-3 align-items-center my-3" v-for="(info, infoIndex) in service.serviceValueInfos" :key="infoIndex">
                          <div class="icon" v-html="info.icon"></div>
                          <div class="d-flex flex-column gap-2">
                            <span class="text-start text-bold">{{ info.titles[currentLanguage] }}</span>
                            <span class="text-start" v-html="info.descriptions[currentLanguage]"></span>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import InputGetList from "@/classes/InputGetList";
  import LogoLoading from "@/components/LogoLoading.vue"
  
  export default {
    components: { LogoLoading },
    data() {
      return {
        imageLoaded: false,
        currentLanguage: this.$i18n.locale,
      };
    },
    mounted() {
      this.initializePage();
    },
    computed: {
      ...mapState({
        servicesOutput: state => state.ourServices.listOutput,
      }),
      services() {
        if (!this.servicesOutput || !this.servicesOutput.data) return null;

        return this.servicesOutput.data.map(service => ({
          ...service,
          serviceValueInfos: service.serviceValueInfos.sort((a, b) => a.position - b.position)
        }));
      },
    },

    methods: {
      ...mapActions({
        getServices: 'ourServices/getList',
      }),

      initializePage() {
  
        // GET list of services
        const itemsPerPage = 999;
        const currentPage = 1;
        const sorter = 1; // asc
        const propertyName = "id";
        const searchText = '';
        const visible = true;
  
        //Make request
        var input = new InputGetList(itemsPerPage, currentPage, sorter, propertyName, searchText, visible);
  
        this.getServices(input);
      },
    },
  }
  </script>
  
<style scoped>
:deep(.icon svg) {
  width: 2rem;
  height: auto;
}
</style>